import { render } from "./SkychartDatapointsTable.vue?vue&type=template&id=476572a0"
import script from "./SkychartDatapointsTable.vue?vue&type=script&lang=js"
export * from "./SkychartDatapointsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__